import { useMutation } from '@tanstack/react-query';
import { apiClient } from 'api';
import { useToast } from 'hooks/useToast';

interface RefineTextPayload {
  question: string;
  prompt?: string;
}

interface RefineTextResponse {
  message: string;
  data: string;
}

const refineTextApi = async (payload: RefineTextPayload): Promise<RefineTextResponse> => {
  const response = await apiClient.post('/assessment/refine-text/', payload);
  return response.data;
};

interface UseRefineTextOptions {
  onSuccess?: (data: string) => void;
}

export const useRefineText = ({ onSuccess }: UseRefineTextOptions = {}) => {
  const { openToast } = useToast();

  const mutation = useMutation({
    mutationFn: refineTextApi,
    onSuccess: (response) => {
      onSuccess?.(response.data);
    },
    onError: (error: any) => {
      const message =
        error?.response?.data?.message || 'Failed to refine text.';
      openToast({
        show: true,
        heading: 'Error',
        text: message,
        type: 'error',
        timeOut: 5000,
      });
    },
    meta: {
    useErrorBoundary: false,
  },
  });

  const refineText = async (payload: RefineTextPayload) => {
    const result = await mutation.mutateAsync(payload);
    return result.data;
  };

  return {
    refineText,
    isLoading: mutation.isPending,
    error: mutation.error,
  };
};
